export default "__VITE_ASSET__DEJMW4x3__"